var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg2Columns = function Svg2Columns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#2columns_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    x: 2,
    y: 1,
    fill: "#fff",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 48,
    fill: "#D1D4DC",
    rx: 2,
    transform: "matrix(1 0 0 -1 10 57)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 48,
    fill: "#D1D4DC",
    rx: 2,
    transform: "matrix(1 0 0 -1 35.5 57)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    x: 2.5,
    y: 1.5,
    stroke: "#D1D4DC",
    rx: 3.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "2columns_svg__a",
    width: 68,
    height: 68,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2083_169419"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2083_169419",
    result: "shape"
  })))));
};
export default Svg2Columns;